import {
  AddressText,
  DateText,
  TopHeaderMenuRoot,
} from '@composites/TopHeaderMenu/styles';
import { usePublicCoLocatedEventsByEventId } from '@utils/apiHooks';
import { counterDate, eventTimeFormat } from '@utils/time';
import { getLanguage, getMode } from '../../store/slices/configSlice';
import { EventMenuRoot, EventTopMenuBody, NavBarRoot } from './styles';

import Icon from '@components/Icon';
import { RowAlignedItems } from '@components/LinearLayout';
import EventMenuDesktop from '@composites/EventMenuDesktop';
import EventMenuMobile from '@composites/EventMenuMobile';
import HeaderBottomComponent from '@composites/TopHeaderMenu/HeaderBottomComponent';
import HeaderTopComponent from '@composites/TopHeaderMenu/HeaderTopComponent';
import { getEventDetails } from '@store/slices/eventSlice';
import { MODE } from '@utils/constants';
import { useTabletWidth } from '@utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { useLocation } from 'react-router-dom';

export const GlobalNav = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const mode = useSelector(getMode);
  const language = useSelector(getLanguage);
  const isTablet = useTabletWidth();
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const pathname = useLocation();

  const startDateCounter = useMemo(() => {
    return counterDate(sluggedEvent?.start_date);
  }, [sluggedEvent?.start_date]);

  const TopHeaderComponent = useMemo(() => {
    if (isTablet) return null;

    return (
      <EventMenuRoot $backgroundColor={sluggedEvent?.design?.themeColor ?? ''}>
        <EventTopMenuBody>
          <TopHeaderMenuRoot>
            <RowAlignedItems $gap="2.4rem">
              <AddressText>
                {`${eventTimeFormat(
                  sluggedEvent?.start_date ?? '',
                  sluggedEvent?.end_date ?? '',
                  language
                )}

             ${sluggedEvent?.location?.name ? ` | ${sluggedEvent?.location?.name}` : ''}`}
              </AddressText>
            </RowAlignedItems>

            <RowAlignedItems>
              {startDateCounter && (
                <RowAlignedItems $gap="0.5rem">
                  <Icon
                    indentLess
                    name="event-pages_calendar"
                    color={theme.color.white}
                  />
                  <DateText color={theme.color.white}>
                    {`${t('still')} ${startDateCounter}`}{' '}
                  </DateText>
                </RowAlignedItems>
              )}
            </RowAlignedItems>
          </TopHeaderMenuRoot>
        </EventTopMenuBody>
      </EventMenuRoot>
    );
  }, [isTablet, sluggedEvent?.design?.themeColor, sluggedEvent?.start_date, sluggedEvent?.end_date, sluggedEvent?.location?.name, language, startDateCounter, theme.color.white, t]);

  if (mode !== MODE.EVENT || pathname.pathname.includes('newsletter-unsubscribe')) return null;

  return (
    <NavBarRoot>
      <EventMenuDesktop TopHeaderComponent={TopHeaderComponent} />

      <EventMenuMobile
        TopHeaderComponentTop={<HeaderTopComponent />}
        TopHeaderComponentBottom={<HeaderBottomComponent />}
      />
    </NavBarRoot>
  );
};
